import React from 'react';
import boxBlueGif from '../../../images/gif/box-blue.gif';
import partySvg from '../../../images/icon/party.svg';

const PartyTime = () => {
    return (
        <div data-aos="fade-up" data-aos-duration="2000" style={{ backgroundImage: `url(${boxBlueGif})`, backgroundSize: 'cover', backgroundPosition: 'center', color: 'white', padding: '20px 20px 200px 20px', borderRadius: 20 }}>
            <div className="row">
                <div className="col-md-6">
                    <h1 className="fw-bolder">Maecenas etiam adipiscing magna</h1>
                </div>
                <div className="col-md-6 text-end">
                    <img className="w-50" src={partySvg} alt="" />
                </div>
            </div>
        </div>
    );
};

export default PartyTime;